import {
  Button,
  NavBar,
  Icon,
  Toast,
  Tabs,
  WhiteSpace,
  SearchBar,
} from "antd-mobile";
//   import { ProductionTaskRejectStatItemDTO } from "../../schema";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router";
import styled from "styled-components";
import instance from "../../../util/axios";
const JixiaoList = styled.div`
  .month {
    background-color: #fff;
  }
  .month ul {
    list-style: none;
    padding: 10px 20px 10px 20px;
    margin: 0;
  }
  .month li {
    border: 1px solid #d7d7d7;
    border-radius: 5px;
    width: 100%;
    padding: 0 10px 0 10px;
    margin-bottom: 10px;
  }
  .month p {
    display: flex;
    justify-content: space-between;
  }
`;
interface Array1 {
  score: string;
  vSheetId: string;
  beTestedStaffCode: string;
  beTestedStaffDepartmentCode: string;
  uuid: string;
}
export default function MonthAssessment() {
  const GridStyle: React.CSSProperties = {
    padding: "5px 0",
  };
  const [tankuang, setTankuang] = useState<{
    visible: boolean;
    rejectId?: string;
    userId?: string;
  }>({
    visible: false,
  });
  const history = useHistory();
  const tabs = [{ title: "未考核" }, { title: "已考核" }];
  const [assessedList, setAssessedList] = useState<Array1[]>([]);
  const [assessed1List, setAssessed1List] = useState<Array1[]>([]);
  const [keyword, setKeyword] = useState<string>();
  const [keyword1, setKeyword1] = useState<string>();
  useEffect(() => {
    let url = window.location.href; //获取请求进来的完整url
    // console.log(url)
    // let tstr = url.substring(url.indexOf('?') + 1).split('&');//先截取url的?后面的参数部分，在根据&分割成参数数组
    let tstr = url.substring(url.indexOf("=") + 1); //获取uuid
    // console.log(tstr)
    instance
      .post(
        `/oa/examMonth/getMonthStaffExecuteList?permissionType=staffMe&vSheetId=` +
          tstr
      )
      .then((resp) => {
        if (resp.data.Status) {
          setAssessedList(resp.data.Data.data);
          setAssessed1List(resp.data.Data.data);
        }
      });
  }, []);
  //搜索未考核
  const searchBarChange = useCallback((keyword) => {
    let url = window.location.href; //获取请求进来的完整url
    // console.log(url)
    // let tstr = url.substring(url.indexOf('?') + 1).split('&');//先截取url的?后面的参数部分，在根据&分割成参数数组
    let tstr = url.substring(url.indexOf("=") + 1); //获取uuid
    // console.log(tstr)
    instance
      .post(
        `/oa/examMonth/getMonthStaffExecuteList?permissionType=staffMe&vSheetId=` +
          tstr +
          "&mobileParam=" +
          keyword
      )
      .then((resp) => {
        if (resp.data.Status === "1") {
          setAssessedList(resp.data.Data.data);
        }
      });
  }, []);
  const noSearch = useCallback(() => {
    let url = window.location.href;
    let tstr = url.substring(url.indexOf("=") + 1);
    instance
      .post(
        `/oa/examMonth/getMonthStaffExecuteList?permissionType=staffMe&vSheetId=` +
          tstr
      )
      .then((resp) => {
        if (resp.data.Status) {
          setAssessedList(resp.data.Data.data);
        }
      });
  }, []);
  //搜索已考核
  const searchBarChange1 = useCallback((keyword1) => {
    let url = window.location.href; //获取请求进来的完整url
    let tstr = url.substring(url.indexOf("=") + 1); //获取uuid
    instance
      .post(
        `/oa/examMonth/getMonthStaffExecuteList?permissionType=staffMe&vSheetId=` +
          tstr +
          "&mobileParam=" +
          keyword1
      )
      .then((resp) => {
        if (resp.data.Status === "1") {
          setAssessed1List(resp.data.Data.data);
        }
      });
  }, []);
  const noSearch1 = useCallback(() => {
    let url = window.location.href;
    let tstr = url.substring(url.indexOf("=") + 1);
    instance
      .post(
        `/oa/examMonth/getMonthStaffExecuteList?permissionType=staffMe&vSheetId=` +
          tstr
      )
      .then((resp) => {
        if (resp.data.Status) {
          setAssessed1List(resp.data.Data.data);
        }
      });
  }, []);
  return (
    <>
      <JixiaoList>
        <div className="body">
          <NavBar
            className="orderNavBar"
            icon={
              <Icon
                type="left"
                onClick={() => {
                  history.push(`/hr/jxassessment`);
                }}
              />
            }
          >
            月份绩效考核
          </NavBar>
          <WhiteSpace />
          <Tabs tabs={tabs} initialPage={"t2"}>
            {/* 未考核 */}
            <div className="month">
              <SearchBar
                value={keyword}
                onChange={(value) => setKeyword(value)}
                placeholder="请输入被考核人姓名"
                className="margin"
                onSubmit={() => {
                  searchBarChange(keyword);
                }}
                onCancel={() => {
                  noSearch();
                }}
              />
              <ul>
                {assessedList.map((item) =>
                  !item.score ? (
                    <li
                      onClick={() => {
                        window.location.href =
                          "/hr/jxassessment/monthassessment/details?vSheetId=" +
                          item.vSheetId +
                          "&" +
                          encodeURI(item.beTestedStaffCode) +
                          "&" +
                          encodeURI(item.beTestedStaffDepartmentCode) +
                          "&" +
                          encodeURI("必填") +
                          "&" +
                          encodeURI(item.uuid);
                      }}
                    >
                      <p>
                        <span>
                          {item.beTestedStaffDepartmentCode.substring(
                            0,
                            item.beTestedStaffDepartmentCode.indexOf("c")
                          )}
                        </span>
                        <span>
                          {item.beTestedStaffCode.substring(
                            0,
                            item.beTestedStaffCode.indexOf("c")
                          )}
                        </span>
                      </p>
                    </li>
                  ) : (
                    ""
                  )
                )}
              </ul>
            </div>
            {/* 已考核 */}
            <div className="month">
              <SearchBar
                value={keyword1}
                onChange={(value) => setKeyword1(value)}
                placeholder="请输入被考核人姓名"
                className="margin"
                onSubmit={() => {
                  searchBarChange1(keyword1);
                }}
                onCancel={() => {
                  noSearch1();
                }}
              />
              <ul>
                {assessed1List.map((item) =>
                  item.score ? (
                    <li
                      onClick={() => {
                        window.location.href =
                          "/hr/jxassessment/monthassessment/details?vSheetId=" +
                          item.vSheetId +
                          "&" +
                          encodeURI(item.beTestedStaffCode) +
                          "&" +
                          encodeURI(item.beTestedStaffDepartmentCode) +
                          "&" +
                          encodeURI(item.score) +
                          "&" +
                          encodeURI(item.uuid);
                      }}
                    >
                      <p>
                        <span>
                          {item.beTestedStaffDepartmentCode.substring(
                            0,
                            item.beTestedStaffDepartmentCode.indexOf("c")
                          )}
                        </span>
                        <span>
                          {item.beTestedStaffCode.substring(
                            0,
                            item.beTestedStaffCode.indexOf("c")
                          )}
                        </span>
                      </p>
                    </li>
                  ) : (
                    ""
                  )
                )}
              </ul>
            </div>
          </Tabs>
        </div>
      </JixiaoList>
    </>
  );
}
